import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { planUpsellEntryPoint } from '@atlassian/jira-portfolio-3-plan-upsell/entrypoint.tsx';

export const planUpsellPageEntryPoint = createPageEntryPoint({
	main: planUpsellEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
